module.exports = __webpack_public_path__ + "static/media/statement.788d23fa.svg";